import React, { Component } from 'react'
import { calculateTimeDifference } from '../../Utils/Datetime'
import './PostComment.scss'
import Token from '../../Utils/Token'
import { apiUrl } from '../../Shared/config'
import Axios from 'axios'

export default class PostComment extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data: {},
            editMode: false,
            tempComment: '',
            saveCommentLoading: false,
            deleteLoading: false
        }
    }

    componentDidMount() {
        this.init(this.props)
    }

    componentWillReceiveProps(props) {
        this.init(props)
    }

    init = (props) => {
        this.setState({
            data: this.props.data || {}
        })
    }

    editComment = () => {
        this.setState({ editMode: true, tempComment: this.state.data.comment })
    }

    saveEditedComment = () => {
        this.setState({
            saveCommentLoading: true
        })
        let state = this.state;
        state.data.comment = state.tempComment
        const url = `${apiUrl}/Post/updatecomment`;
        Axios.post(url, state.data).then(res => {
            if (!res.data.error && res.data.data) {
                state.editMode = false;
                state.saveCommentLoading = false
                state.tempComment = ''
                this.setState(state)
            } else {
                alert(res.data.error)
                state.saveCommentLoading = false
                this.setState(state)
            }
        }).catch(err => {
            alert(JSON.stringify(err))
            state.saveCommentLoading = false
            this.setState(state)
        })
    }

    onChangeEditComment = (e) => {
        let state = this.state;
        state.tempComment = e.target.value
        this.setState(state)
    }

    cancelEditedComment = () => {
        this.setState({ editMode: false, tempComment: '' })
    }

    deleteComment = () => {
        this.setState({
            deleteLoading: true
        })
        let state = this.state;
        const url = `${apiUrl}/Post/deletecomment/${state.data._id}`;
        Axios.get(url).then(res => {
            if (!res.data.error && res.data.data) {
                state.deleteLoading = false
                this.setState(state)
                this.props.getPost();
            } else {
                alert(res.data.error)
                state.deleteLoading = false
                this.setState(state)
            }
        }).catch(err => {
            alert(JSON.stringify(err))
            state.deleteLoading = false
            this.setState(state)
        })
    }

    render() {
        const { data, editMode, tempComment, saveCommentLoading, deleteLoading } = this.state
        const userId = Token.getValue("_id");

        if (data.commenterInfo) {
            return (
                <div className='comment-container'>
                    <div className='commenter-info'>
                        <div className='name'>{`${data.commenterInfo.firstName} ${data.commenterInfo.lastName}`}</div>
                        <div className='time'>{calculateTimeDifference(data.commentDate)}</div>
                    </div>
                    {
                        editMode ? (
                            <div className='comment-description edit-mode'>
                                <textarea onChange={this.onChangeEditComment} value={tempComment || ''} id='comment'></textarea>
                                <div className='comment-actions-edit'>
                                    <button onClick={this.cancelEditedComment} className='btn-new btn-success'>Cancel</button>
                                    {
                                        !saveCommentLoading ? (
                                            <button onClick={this.saveEditedComment} className='btn-new btn-success'>Save</button>
                                        ) : (
                                                <button className='btn-new btn-success'>Please wait</button>
                                            )
                                    }
                                </div>
                            </div>
                        ) : (
                                <div className='comment-description'>{data.comment}</div>
                            )
                    }
                    {
                        userId === data.commenterInfo._id && !editMode ? (
                            <div className='comment-actions'>
                                <div onClick={this.editComment} className='action-item'>
                                    <img alt='edit' src={require('../../Shared/icons/pencil-edit.svg')} />
                                    <div className='like-count'>Edit</div>
                                </div>
                                {
                                    !deleteLoading ? (
                                        <div onClick={this.deleteComment} className='action-item'>
                                            <img alt='delete' src={require('../../Shared/icons/delete.svg')} />
                                            <div className='like-count'>Delete</div>
                                        </div>
                                    ) : (
                                            <div className='action-item'>
                                                <img alt='delete' src={require('../../Shared/icons/dead-delete.svg')} />
                                                <div className='like-count'>Please wait</div>
                                            </div>
                                        )
                                }
                            </div>
                        ) : null
                    }
                </div>
            )
        }

        return null;
    }
}
